// extracted by mini-css-extract-plugin
export default {"Navbar":"Navbar_Navbar__kJyoZ"};